export default __webpack_public_path__ + "static/media/image14.7fe2711f.png";